import type React from "react";
import "./BlurredImage.css";

type BlurredImageProps = {
	blur: number;
	image: string;
};

export const BlurredImage: React.FC<BlurredImageProps> = ({ blur, image }) => {
	return (
		<div className="image">
			<img
				draggable={false}
				className="blurred-image"
				alt="blurred-image"
				src={image}
				style={{ filter: `blur(${blur}px)` }}
			/>
		</div>
	);
};
